import { walletService } from '../../helpers/services/wallet.service'
import i18n from '@/i18n'
import { sharedHelper } from '@/utils'

export const state = {
  // The signed-in user's own wallet.
  myWallet: { balance: 0, currencyCode: 'MYR', collectedToday: 0 },
  myTransactions: { data: [], meta: null },
  // Every wallet, for the back office.
  wallets: { data: [], meta: null, totalBalance: 0 },
  walletTransactions: { data: [], meta: null },
  status: { list: true, save: true },
}

export const WALLET_MODULE = 'wallet'

export const GET_MY_WALLET = 'getMyWallet'
export const GET_MY_WALLET_TRANSACTIONS = 'getMyWalletTransactions'
export const GET_ALL_WALLETS = 'getAllWallets'
export const GET_WALLET_TRANSACTIONS = 'getWalletTransactions'
export const WITHDRAW_FROM_WALLET = 'withdrawFromWallet'
export const ADJUST_WALLET = 'adjustWallet'

const REQUESTING = 'requesting'
const SUCCESS = 'commonSuccess'
const FAILURE = 'commonFailure'
const MY_WALLET_SUCCESS = 'myWalletSuccess'
const MY_TXN_SUCCESS = 'myTransactionsSuccess'
const WALLETS_SUCCESS = 'walletsSuccess'
const TXN_SUCCESS = 'transactionsSuccess'

function mapWallet(item) {
  return {
    uuid: item.uuid,
    userUuid: item.user_uuid,
    userName: item.user_name,
    agentCode: item.agent_code,
    email: item.email,
    balance: Number(item.balance ?? 0),
    currencyCode: item.currency_code || 'MYR',
    collectedToday: Number(item.collected_today ?? 0),
    updatedAt: item.updated_at,
  }
}

function mapTransaction(item) {
  return {
    uuid: item.uuid,
    type: item.type,
    source: item.source,
    amount: Number(item.amount ?? 0),
    balanceBefore: Number(item.balance_before ?? 0),
    balanceAfter: Number(item.balance_after ?? 0),
    refDocNo: item.ref_doc_no,
    remarks: item.remarks,
    // Who did it — the admin for a withdrawal, the agent for a collection.
    actorName: item.actor_name,
    createdAt: item.created_at,
  }
}

function mapMeta(r) {
  return r?.meta || null
}

export const actions = {
  [GET_MY_WALLET]({ commit }) {
    return walletService.getMine().then((r) => {
      commit(MY_WALLET_SUCCESS, r); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
    })
  },
  [GET_MY_WALLET_TRANSACTIONS]({ commit }, payload) {
    commit(REQUESTING, 'list')
    return walletService.getMyTransactions(payload?.params || {}).then((r) => {
      commit(MY_TXN_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_ALL_WALLETS]({ commit }, payload) {
    commit(REQUESTING, 'list')
    return walletService.getAll(payload?.params || {}).then((r) => {
      commit(WALLETS_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [GET_WALLET_TRANSACTIONS]({ commit }, { userUuid, params }) {
    commit(REQUESTING, 'list')
    return walletService.getTransactions(userUuid, params || {}).then((r) => {
      commit(TXN_SUCCESS, r); commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code); commit(FAILURE)
    })
  },
  [WITHDRAW_FROM_WALLET]({ commit }, { userUuid, data }) {
    commit(REQUESTING, 'save')
    return walletService.withdraw(userUuid, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('wallet.withdrawn'))
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
      commit(FAILURE)
      // Swallowed by design: the caller keeps the dialog open on failure.
      return null
    })
  },
  [ADJUST_WALLET]({ commit }, { userUuid, data }) {
    commit(REQUESTING, 'save')
    return walletService.adjust(userUuid, data).then((r) => {
      sharedHelper.alertSuccessMessage(i18n.t('wallet.adjusted'))
      commit(SUCCESS); return r
    }).catch((e) => {
      sharedHelper.alertErrorMessage(sharedHelper.getErrorMessage(e), e?.response?.data?.code)
      commit(FAILURE)
      return null
    })
  },
}

export const mutations = {
  [MY_WALLET_SUCCESS](state, r) {
    const w = mapWallet(r.data || {})
    state.myWallet = { balance: w.balance, currencyCode: w.currencyCode, collectedToday: w.collectedToday }
  },
  [MY_TXN_SUCCESS](state, r) {
    state.myTransactions = { data: (r.data || []).map(mapTransaction), meta: mapMeta(r) }
  },
  [WALLETS_SUCCESS](state, r) {
    state.wallets = {
      data: (r.data || []).map(mapWallet),
      meta: mapMeta(r),
      totalBalance: Number(r.total_balance ?? 0),
    }
  },
  [TXN_SUCCESS](state, r) {
    state.walletTransactions = { data: (r.data || []).map(mapTransaction), meta: mapMeta(r) }
  },
  [FAILURE](state) { state.status = { list: true, save: true } },
  [REQUESTING](state, type) { state.status[type] = false },
  [SUCCESS](state) { state.status = { list: true, save: true } },
}
